import { Component } from 'react';
import PropTypes from 'prop-types';

import BaseSender from 'core/components/MetricsEventSender/BaseSender';

import { withRouter } from 'core/libs/router';

import { createPath } from 'core/utils/url-helper';
import { commonRcmEventTypes } from 'core/utils/prop-types/rcm';

// Описываем, в каких хуках жизненного цикла должны срабатывать события
const eventRules = {
  hubpageview: {
    onMount: true,
    onUpdate: true,
  },
  pageview: {
    onMount: true,
    onUpdate: false,
  },
  blockinit: {
    onMount: true,
    onUpdate: true,
  },
};


class RcmEventsSender extends Component {
  static propTypes = {
    hubpageview: PropTypes.object,
    pageview: PropTypes.object,
    blockinit: PropTypes.object,
    pageread: PropTypes.object,
    /**
     * Событие, которое будет отправлятся при показе
     */
    show: commonRcmEventTypes,
    /**
     * Событие, которое будет отправлятся по клику
     */
    click: commonRcmEventTypes,
    /**
     * BaseSender оборачивает `children` в `div`.<br/>
     * Можно задать класс для этой обертки, что бывает полезно при верстке.
     */
    className: PropTypes.string,

    /** @ignore */
    location: PropTypes.object,
  };

  componentDidMount() {
    Object.keys(eventRules).forEach(eventName => {
      if (this.props[eventName] && eventRules[eventName].onMount) {
        this.sendEvent({ name: eventName, params: this.props[eventName] });
      }
    });
  }

  componentDidUpdate(prevProps) {
    /**
     * Используем в качестве проверки уникальности location
     * только pathname и search, чтобы исключить вызов событий
     * при смене слайдов галереи с включённой хэш-навигацией.
     */
    const prevLocationKey = createPath(prevProps.location);
    const currentLocationKey = createPath(this.props.location);

    if (prevLocationKey !== currentLocationKey) {
      Object.keys(eventRules).forEach(eventName => {
        if (this.props[eventName] && eventRules[eventName].onUpdate) {
          this.sendEvent({ name: eventName, params: this.props[eventName] });
        }
      });
    }
  }

  sendEvent = eventDescriptor => {
    if (!eventDescriptor || !eventDescriptor.name || !eventDescriptor.params) return;

    const { name, params } = eventDescriptor;
    window.rcm && window.rcm(name, params);
  };

  handleShow = () => {
    if (this.props.show) {
      this.sendEvent({ name: 'show', params: this.props.show });
    }
    if (this.props.pageread) {
      this.sendEvent({ name: 'pageread', params: this.props.pageread });
    }
  };

  handleClick = () => {
    if (this.props.click) {
      this.sendEvent({ name: 'click', params: this.props.click });
    }
  };


  render() {
    if (this.props.pageread || this.props.show || this.props.click) {
      return (
        <BaseSender
          onShow={this.handleShow}
          onClick={this.handleClick}
          checkScrollY
          className={this.props.className}
        >
          {this.props.children}
        </BaseSender>
      );
    }

    return this.props.children;
  }
}

const RcmEventsSenderWithHOCs = withRouter(RcmEventsSender);
RcmEventsSenderWithHOCs.displayName = 'RcmEventsSender';

export { RcmEventsSender as StorybookComponent };
export default RcmEventsSenderWithHOCs;
